// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__WM-RJ","label":"CategoryService_label__2AlhW","location":"CategoryService_location__3x_zw"};